import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-down-small"} maskId="square-filled-radius-0-stroke-1-IconChevronDownSmall"><path fillRule="evenodd" clipRule="evenodd" d="M12.0001 14.707L16.7072 9.99992L16.0001 9.29282L12.0001 13.2928L8.00008 9.29282L7.29297 9.99992L12.0001 14.707Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronDownSmall;
